<!--
 * Copyright    :Copyright© 2022 AOMEI
 * Abstract     :
 * Date         :2023-04-05 20:09:14
 * Author       :
 * LastEditors  :chenjia
 * LastEditTime :2025-04-21 15:12:19
 * FilePath     :\AV-COM-user-backend\src\App.vue
 * RevisionHistory:
-->
<template>
    <div id="app" :class="`av-${lang}`">
        <loading v-if="pageLoading" />
        <router-view v-if="isRouterAlive && !pageLoading" />
    </div>
</template>
<script>
import Loading from "@/components/Loading.vue";
import { debounce, currentLang } from "@/utils/util";
import { mapMutations, mapState } from "vuex";
export default {
    provide() {
        return {
            reload: this.reload,
        };
    },
    components: {
        Loading,
    },
    data() {
        return {
            lang: "en",
            isRouterAlive: true,
            pageLoading: process.env.NODE_ENV === "development" ? false : true, // 开启页面未加载
        };
    },
    watch: {
        perInfo: {
            handler(to) {
                // to.id && ();
                if (to?.id) {
                    this.pageLoading = false;
                }
            },
            immediate: true,
            deep: true,
        },
    },
    computed: {
        ...mapState({
            perInfo: (state) => state.userinfo.PERINFO,
        }),
    },
    methods: {
        ...mapMutations({
            setCHeight: "app/SET_HEIGHT",
            setCWidth: "app/SET_WIDTH",
        }),
        resize() {
            const width = document.documentElement.clientWidth; // 窗口宽度
            const height = document.documentElement.clientHeight; // 窗口高度
            this.setCHeight(height);
            this.setCWidth(width);
        },
        reload() {
            this.isRouterAlive = false;
            this.$nextTick(function () {
                this.isRouterAlive = true;
            });
        },
    },
    created() { },
    mounted() {
        // this.resize();
        const debouncedResize = debounce(this.resize, 500);
        window.onresize = debouncedResize;

        this.lang = currentLang();
    },
};
</script>

<style lang="less"></style>
